import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import { type UserSegmentEntity } from '../entities/sections.entity'

export class GetSectionsSummaryQuery extends GetNetworkQuery {
  constructor(
    private readonly fromDate: string,
    private readonly toDate: string,
    private readonly fromPrevious: string,
    private readonly toPrevious: string,
    private readonly userSegment: UserSegmentEntity,
    private readonly organization: string
  ) {
    super(ApiEndpoint.EngagementSectionsSummary)
  }

  public get queryParameters(): HttpParameters {
    return {
      from_date: this.fromDate,
      to_date: this.toDate,
      from_previous: this.fromPrevious,
      to_previous: this.toPrevious,
      user_segment: this.userSegment,
      organization: this.organization
    }
  }
}
